import axios from "axios"

export const actions = {

    //Inspection Contract
    GetInspectionContractPending(context, data){
        return axios.get(`Inspection/Contract/Pending/${data.campusId}/${data.cycle}`);
    },
    GetInspectionContractItemsPending(context, data){
        return axios.get(`Inspection/Contract/Pending/Items/${data}`);
    },
    GetInspectionContractToExpire(context, data){
        return axios.get(`Inspection/Contract/ToExpire/${data.campusId}/${data.cycle}`);
    },
    GetInspectionContractExpired(context, data){
        return axios.get(`Inspection/Contract/Expired/${data.campusId}/${data.cycle}`);
    },
    GetInspectionContractCompleted(context, data){
        return axios.get(`Inspection/Contract/Completed/${data.campusId}/${data.cycle}`);
    },
    GetInspectionContractItemsCompleted(context, data){
        return axios.get(`Inspection/Contract/Completed/Items/${data}`);
    },
    GetInspectionContractByDu(context, data){
        return axios.get(`Inspection/Contract/Pending/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetInspectionContractCompletedByDu(context, data){
        return axios.get(`Inspection/Contract/Completed/Items/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },

}